import {IButtonProps} from 'brandComponents/Button/IButton';
import {IContentProps} from '../Content/IContent';

export enum EButtonLinkTarget {
	'Same Tab' = '_self',
	'New Tab' = '_blank',
}

export interface IButtonContentfulProps
	extends Omit<IContentProps, 'data'>,
		Pick<IButtonProps, 'variant' | 'fullWidth'> {
	title: string;
	targetUrl?: string;
	targetPage?: {props?: {slug: string}};
	targetElement?: string;
	targetCategory?: string;
	linkTarget?: EButtonLinkTarget;
	queryParameters: Record<string, string>;
}
